import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import PageTitle from "components/PageTitle";
import Calendar from 'react-calendar'
import styles from "./index.module.css";
import Report from "./report";

import ReactMarkdown from 'react-markdown'

import * as ajax from "helpers/ajax";
import MDTypography from "../../components/MDTypography";
import CalendarIcon from '../../components/CalendarIcon'
import { isAccordoQuadro } from "helpers/functions.js"

import { ROLES } from "constant"

export default class GestioneAttivita extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listCommessa: [],
            selectedCommessa: null,
            selectedDay:this.props.selectedDate ? new Date(this.props.selectedDate) : new Date(),
            currentNote: "",
            currentNoteAltre: "",
            currentNoteTrasporti: "",
            currentNoteVerifiche: "",

            noteID: null,
            openReport: false
        };

        this.refCalendar = null;
        this.refCalendarIcon = null;
    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("commessas?populate=*", this.loadListCommessa)
    }

    loadNote = () => {
        ajax.ajaxGetStrapi("commessa-notes?populate=*&filters[data][$eq]=" + this.convertDate(this.state.selectedDay) + "&filters[commessa][id][$eq]=" + this.state.selectedCommessa.id, this.loadNoteCallback)
    }

    loadNoteCallback = (response) => {
        if (response.data.length>0) {
            this.setState({
                currentNote: response.data[0].note ? response.data[0].note:"",
                currentNoteAltre: response.data[0].note_altre_imprese ? response.data[0].note_altre_imprese:"",
                currentNoteTrasporti: response.data[0].note_trasposrti ? response.data[0].note_trasposrti:"",
                currentNoteVerifiche: response.data[0].note_verifiche ? response.data[0].note_verifiche:"",
                noteID: response.data[0].id
            })
        } else {
            this.setState({
                currentNote: "",
                currentNoteAltre: "",
                currentNoteTrasporti: "",
                currentNoteVerifiche: "",
                noteID: null
            })
        }
    }

    loadListCommessa = (response) => {
        let arr = response.data;
        arr = arr.filter(item => !isAccordoQuadro(item));
        this.setState({ listCommessa: arr }, this.checkParam)
    }

    checkParam = () => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let id = params.get('id');

        this.state.listCommessa.forEach((el) => {
            if (el.id == id) {
                let selectedCommessa = {
                    "label": el.nome,
                    "id": el.id
                }

                this.setState({ selectedCommessa: selectedCommessa }, this.loadNote)
                return
            }
        })

    }


    listCommessaArray = () => {
        let arr = [];
        this.state.listCommessa.map((el) => {
            if (el.stato == "finito") {return }
            arr.push({
                "label": el.nome,
                "id": el.id
            })
        })
        return arr
    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }



    changeDay = (date) => {
        this.setState({ selectedDay: date }, this.loadNote)
    }

    saveNote = (day, text,key) => {
        let data = {
            data: {
                commessa: this.state.selectedCommessa.id,
                data: this.convertDate(day),
           }
        }

        data.data[key] = text;

        if (this.state.noteID) {
            ajax.ajaxPutStrapi("commessa-notes/" + this.state.noteID, data, this.saveNoteCallback);
        } else {
            ajax.ajaxPostStrapi("commessa-notes", data, this.saveNoteCallback);
        }
    }

    saveNoteCallback = (response) => {
        this.setState({noteID:response.data.id})
    }

    openReport = () => {
        this.setState({ openReport: true })
    }

    render() {

        if (this.state.openReport) {
            return <Report data={this.state.selectedDay} backFunction={() => this.setState({ openReport: false })} />
        }

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione Attività"}
                    subtitle={""}
                    icon={"calendar_month"}
                    menu={[{ label: "Genera Report", function: this.openReport }]}
                />

                <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={this.listCommessaArray()}
                        renderInput={(params) => <TextField {...params} label="Seleziona commessa" />}
                        value={this.state.selectedCommessa ? this.state.selectedCommessa.label : ""}
                        onChange={(event, newValue) => {
                            if (!newValue) { return}
                            this.setState({ selectedCommessa:newValue}, this.loadNote)
                        }}
                    />
                </MDBox>

                {this.state.selectedCommessa ?
                    <Grid container mt={5}>
                        <Grid item sm={12} md={6} pr={2}>
                            <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                                <MDTypography variant={"h5"} textTransform={"uppercase"} mb={2} >Calendario Attività <CalendarIcon ref={(ref) => this.refCalendarIcon = ref} onChange={(val) => { this.changeDay(new Date(val));this.refCalendar.value=(new Date(val));} } /></MDTypography>

                                <Calendar
                                    inputRef={(ref) => this.refCalendar = ref}
                                    className={styles.calendar}
                                    onChange={(e) => { this.changeDay(e); this.refCalendarIcon.ref.value = this.convertDate(e) }}
                                    value={this.state.selectedDay}
                                    activeStartDate={this.state.selectedDay}
                                    onActiveStartDateChange={(val) => this.setState({ selectedDay: val.activeStartDate })}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item sm={12} md={6} pl={2}>
                            <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                                <MDInput
                                    value={this.state.currentNote}
                                    fullWidth
                                    rows={13}
                                    multiline={true}
                                    label={"Note attività"}
                                    onChange={(e) => { this.setState({ currentNote: e.target.value }) }}
                                    onBlur={() => this.saveNote(this.state.selectedDay, this.state.currentNote, "note")}
                                    disabled={[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? true :false}
                                />
                            </MDBox>
                        </Grid>
                        {/*note altre imprese*/}
                        <Grid item sm={12} md={6} mt={2} pr={2}>
                            <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                                <MDInput
                                    value={this.state.currentNoteAltre}
                                    fullWidth
                                    rows={15}
                                    multiline={true}
                                    label={"Note altre imprese"}
                                    onChange={(e) => { this.setState({ currentNoteAltre: e.target.value }) }}
                                    onBlur={() => this.saveNote(this.state.selectedDay, this.state.currentNoteAltre, "note_altre_imprese")}
                                    disabled={[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? true : false}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item sm={12} md={6} pl={2} mt={2}>

                            {/*note trasporti*/}
                            <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                                <MDInput
                                    value={this.state.currentNoteTrasporti}
                                    fullWidth
                                    rows={5}
                                    multiline={true}
                                    label={"Note trasporti"}
                                    onChange={(e) => { this.setState({ currentNoteTrasporti: e.target.value }) }}
                                    onBlur={() => this.saveNote(this.state.selectedDay, this.state.currentNoteTrasporti, "note_trasposrti")}
                                    disabled={[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? true : false}
                                />
                            </MDBox>

                            {/*note verifiche*/}
                            <MDBox sx={{ backgroundColor: "white!important" }} mt={3} p={3} borderRadius="lg" shadow="lg" >
                                <MDInput
                                    value={this.state.currentNoteVerifiche}
                                    fullWidth
                                    rows={5}
                                    multiline={true}
                                    label={"Note verifiche"}
                                    onChange={(e) => { this.setState({ currentNoteVerifiche: e.target.value }) }}
                                    onBlur={() => this.saveNote(this.state.selectedDay, this.state.currentNoteVerifiche, "note_verifiche")}
                                    disabled={[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? true : false}
                                />
                            </MDBox>
                        </Grid>
                    </Grid>
                    : null
                }
            </DashboardLayout>
        )
    }
}


